import React, { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Philosophy from './components/Philosophy';
import Packages from './components/Packages';
import Requirements from './components/Requirements';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  useEffect(() => {
    // Add Font Awesome
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
    document.head.appendChild(link);

    // Smooth scroll reveal animations
    const observerOptions = {
      threshold: 0.15,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          // Add staggered animation delay
          setTimeout(() => {
            entry.target.classList.add('animate-slide-up');
          }, index * 150);
        }
      });
    }, observerOptions);

    // Observe all sections for smooth entry
    const sections = document.querySelectorAll('section');
    sections.forEach(section => {
      observer.observe(section);
    });

    return () => {
      if (link.parentNode) {
        link.parentNode.removeChild(link);
      }
      observer.disconnect();
    };
  }, []);

  return (
    <div className="App antialiased">
      <Header />
      <main>
        <Hero />
        <Philosophy />
        <Packages />
        <Requirements />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
